export const CREATE_LABEL_CONTENT_CONFIGURE_LABEL = 'CREATE_LABEL_CONTENT_CONFIGURE_LABEL';
export const configureLabel = (sellerLabelProviderId, rate, fulfillmentPlanId) => ({
  type: CREATE_LABEL_CONTENT_CONFIGURE_LABEL,
  fulfillmentPlanId,
  sellerLabelProviderId,
  rate,
});

export const CREATE_LABEL_ACTION = 'CREATE_LABEL_ACTION';
export const createLabel = ({
  fulfillmentPlanId,
  doNotPrint = false,
  returnLabelMetadata = undefined,
  labelMetadata = {},
  purchaseCorrelationId = '',
}) => ({
  type: CREATE_LABEL_ACTION,
  fulfillmentPlanId,
  doNotPrint,
  returnLabelMetadata,
  labelMetadata,
  purchaseCorrelationId,
});

export const CREATE_LABEL_CONTENT_SET_COST_REVIEW_GUID = 'CREATE_LABEL_CONTENT_SET_COST_REVIEW_GUID';
export const setCostReviewGuid = (costReviewJobGuid) => ({
  type: CREATE_LABEL_CONTENT_SET_COST_REVIEW_GUID,
  costReviewJobGuid,
});

export const CREATE_LABEL_CONTENT_UPDATE_RETURNS_FLAG = 'CREATE_LABEL_CONTENT_UPDATE_RETURNS_FLAG';
export const updateReturnsFlag = (fulfillmentPlanId, isCreatingReturnLabel) => ({
  type: CREATE_LABEL_CONTENT_UPDATE_RETURNS_FLAG,
  fulfillmentPlanId,
  isCreatingReturnLabel,
});

export const CREATE_LABEL_CONTENT_SET_FULFILLMENT_PLAN_ID = 'CREATE_LABEL_CONTENT_SET_FULFILLMENT_PLAN_ID';
export const setFulfillmentPlanId = (fulfillmentPlanId) => ({
  type: CREATE_LABEL_CONTENT_SET_FULFILLMENT_PLAN_ID,
  fulfillmentPlanId,
});

export const CREATE_LABEL_ACTION_END = 'CREATE_LABEL_ACTION_END';
export const createLabelActionEnd = (metadata) => ({
  type: CREATE_LABEL_ACTION_END,
  metadata,
});
